/**
 * @file experienceDetailsMeta.component.tsx
 * @path apps/website/src/features/experiences/components/experienceDetailsMeta.component.tsx
 * @description UI component
 */

import { ElementType } from "react";

export const MetadataItem = ({
  icon: Icon,
  label,
  value,
}: {
  icon: ElementType;
  label: string;
  value: string;
}) => (
  <div className="flex items-center gap-3">
    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent/10 border border-accent/40">
      <Icon className="h-5 w-5 text-accent" />
    </div>
    <div className="flex flex-col">
      <span className="text-[9px] font-montserrat font-black uppercase tracking-[0.3em] text-muted-foreground mb-0.5">
        {label}
      </span>
      <span className="text-sm font-bold text-foreground">{value}</span>
    </div>
  </div>
);
